/* Shared ion-list field layout for entity detail cards (submittals, RFIs, etc.) */

.detail-card-list {
  background: transparent;
}

.detail-card-list ion-item-divider {
  --background: transparent;
  --color: var(--ion-text-color);
  --padding-start: 0;
  --inner-padding-end: 0;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--background-color-step-200);
  display: flex;
  flex-direction: column;
}

.detail-card-list ion-item {
  --background: transparent;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-border-width: 0;
  --min-height: 0;
}

.detail-card-list ion-label {
  margin-top: 0;
  margin-bottom: 0;
}

.detail-card-list ion-item-group {
  flex: 1;
  padding: 0.2rem 0;
  width: 100%;
}
